module.exports = __webpack_public_path__ + "img/8_22.e64ca88c.png";